export default "__VITE_ASSET__237ad1ec__"